import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { getArtifact } from './client';
import { keys } from './keys';

/**
 * Fetch one artifact for viewing (Drop 6 / S11) — the data behind the centre-pane
 * View flow (`GET /workstreams/{id}/artifacts/{artifactId}`). Keyed by
 * `keys.workstream.artifact(workstreamId, artifactId)`, which nests under the list
 * key so S10's delete-invalidation also drops a viewed file's cache (it then 404s
 * and `FileViewPanel` self-heals). Honours the shared QueryClient defaults
 * (non-zero `staleTime`, no retry on 4xx — so a 404 surfaces immediately).
 */
export function useGetArtifact(workstreamId: string, artifactId: string) {
  const { getAccessToken } = useAuth();
  return useQuery({
    queryKey: keys.workstream.artifact(workstreamId, artifactId),
    queryFn: ({ signal }) => getArtifact(workstreamId, artifactId, { getAccessToken, signal }),
  });
}
